import e from "react";
const r = ({
  componentsLinks: t,
  onNavigate: a
}) => t?.length ? /* @__PURE__ */ e.createElement("div", { className: "bl-container bl-container--medium bl-m-b-4" }, /* @__PURE__ */ e.createElement("h4", { className: "bl-size-3 bl-p-b-3" }, "På denne siden:"), /* @__PURE__ */ e.createElement("ul", { className: "bl-link-list bl-link-list--two-column" }, t.map((l) => /* @__PURE__ */ e.createElement("li", { key: `top-link-${l.hash}` }, /* @__PURE__ */ e.createElement("a", { href: `#${l.hash}`, onClick: () => a(l) }, l.display))))) : /* @__PURE__ */ e.createElement(e.Fragment, null);
export {
  r as default
};
//# sourceMappingURL=index.es37.js.map
